import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, CardActions, CardContent, CardMedia, Grid, Stack, Typography, IconButton, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import './mentorHomepage.css';
import { toast } from "react-toastify";
import { Context as AppContext } from "../../context/AppContext";
import cardBackground1 from '../../assets/c-background1.jpg'
import cardBackground2 from '../../assets/c-background2.jpg'
import cardBackground3 from '../../assets/c-background3.jpg'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { truncateWords, getImageUrl, getPartnerByName } from '../../utils/functions';
import confetti from 'canvas-confetti';
import { Public } from '@mui/icons-material';

const ListOfMentors = ({ mentors }) => {
    const theme = useTheme();
    const { state: { currentUser }, updateUserData } = useContext(AppContext);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    
   

    function triggerConfetti() {
        const duration = 3 * 1000;
        const animationEnd = Date.now() + duration;
        const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

        function randomInRange(min, max) {
            return Math.random() * (max - min) + min;
        }

        const interval = setInterval(function () {
            const timeLeft = animationEnd - Date.now();

            if (timeLeft <= 0) {
                return clearInterval(interval);
            }

            const particleCount = 50 * (timeLeft / duration);

            // Since they are falling down, start a bit higher than random
            confetti({
                ...defaults,
                particleCount,
                origin: { x: randomInRange(0.1, 0.3), y: randomInRange(0, 0.2) }
            });
            confetti({
                ...defaults,
                particleCount,
                origin: { x: randomInRange(0.7, 0.9), y: randomInRange(0, 0.2) }
            });
        }, 250);
    }

    function applyForMentorship(mentorUid) {
        currentUser.hasApplied = true
        currentUser.mentorApplications = currentUser.mentorApplications ? [...currentUser.mentorApplications, mentorUid] : [mentorUid]
        updateUserData(currentUser)
        toast.success("You have applied!")
        triggerConfetti(); // Trigger confetti animation
        console.log('Applying for mentorship')
    }

    function openMentorProfile(mentorUid) {
        // navigate(`/mentor/${mentorUid}`)
    }

    function toggleDescription(mentorUid) {
        setExpandedDescriptions(prev => ({
            ...prev,
            [mentorUid]: !prev[mentorUid]
        }));
    }

    function getApplicationStatus(mentorUid) {
        console.log(currentUser?.mentorUid !== null || currentUser?.mentorUid !== "" || currentUser?.mentorUid !== undefined)
        if (currentUser?.mentorApplications?.includes(mentorUid)) {
            return "Applied"
        }else if (currentUser?.mentorUid !== null && currentUser?.mentorUid !== "" && currentUser?.mentorUid !== undefined) {
            return "Mentorship in progress"
        } else if (currentUser?.hasApplied) {
            return "Applied Elsewhere"
        } else {
            return "Apply"
        }
    }


    return (
        <Box>
            <Grid container spacing={3}>
                {mentors.map((mentor, index) => {
                    const backgrounds = [cardBackground1, cardBackground2, cardBackground3];
                    const backgroundImage = backgrounds[index % 3]; // Cycles through 0,1,2,0,1,2,...
                    return (
                        <Grid item xs={12} sm={6} md={6} lg={4} xl={4} key={mentor.uid}>
                            <Card sx={{
                                width: '100%',
                                height: '100%',
                                minHeight: '340px',
                                maxWidth: '400px',
                                mx: 'auto',
                                position: 'relative',
                                overflow: 'hidden',
                                borderRadius: '16px',
                                display: 'flex',
                                flexDirection: 'column',
                                border: '1px solid #e2e8f0',
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 8px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
                                }
                            }}>
                                <Box sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundImage: `url(${backgroundImage})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    filter: 'blur(5px)',
                                    transform: 'scale(1.1)',
                                    '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity as needed
                                    }
                                }} />
                                <Box sx={{
                                    position: 'relative',
                                    zIndex: 1,
                                    color: 'white',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: '100%'
                                }}>
                                    <Box sx={{
                                        height: '100px',
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        p: 2,
                                        boxSizing: 'border-box'
                                    }}>
                                        <Box
                                            component="img"
                                            sx={{
                                                maxHeight: '60px',
                                                maxWidth: '160px',
                                                width: 'auto',
                                                height: 'auto',
                                                objectFit: 'contain',
                                                filter: 'brightness(0) invert(1)',
                                                opacity: 0.95,
                                                display: 'block'
                                            }}
                                            src={getImageUrl(mentor.company)}
                                            alt={`${mentor.company} logo`}
                                        />
                                    </Box>
                                    <CardContent sx={{
                                        flexGrow: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        pb: 0
                                    }}>
                                        <Typography variant={'h5'}><strong>{mentor.name.replace(/\b\w/g, char => char.toUpperCase())}</strong></Typography>
                                        <Typography sx={{ mb: 1 }} variant={'body1'}>{mentor.jobTitle.replace(/\b\w/g, char => char.toUpperCase())}</Typography>
                                        <Typography variant={'body1'} sx={{ mb: 2 }}>
                                            {expandedDescriptions[mentor.uid] 
                                                ? mentor.jobDescription
                                                : truncateWords(mentor.jobDescription, 10)
                                            }
                                            {mentor.jobDescription.split(' ').length > 10 && (
                                                <Button
                                                    size="small"
                                                    onClick={() => toggleDescription(mentor.uid)}
                                                    sx={{
                                                        color: 'white',
                                                        textTransform: 'none',
                                                        fontSize: '0.8rem',
                                                        p: 0,
                                                        minWidth: 'auto',
                                                        ml: 0.5,
                                                        '&:hover': {
                                                            backgroundColor: 'transparent',
                                                            textDecoration: 'underline'
                                                        }
                                                    }}
                                                >
                                                    {expandedDescriptions[mentor.uid] ? 'See less' : 'See more'}
                                                </Button>
                                            )}
                                        </Typography>
                                        <Box sx={{ flexGrow: 1 }} />
                                        {getApplicationStatus(mentor.uid) === 'Applied' && (
                                            <Typography
                                                variant={'body2'}
                                                sx={{
                                                    fontSize: '0.85rem',
                                                    fontStyle: 'italic',
                                                    color: 'rgba(255, 255, 255, 0.7)',
                                                    mb: 0
                                                }}
                                            >
                                                You will be notified when the mentor accepts your application
                                            </Typography>
                                        )}
                                    </CardContent>
                                    <CardActions sx={{ p: 2, pt: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Button
                                            size="small"
                                            variant="contained"
                                            disabled={currentUser?.hasApplied || currentUser?.internshipUid}
                                            onClick={() => applyForMentorship(mentor.uid)}
                                            sx={{
                                                bgcolor: theme.palette.primary.main,
                                                color: 'white',
                                                fontSize: '0.875rem',
                                                fontWeight: 600,
                                                px: 3,
                                                py: 1.25,
                                                borderRadius: '12px',
                                                textTransform: 'none',
                                                boxShadow: `0 4px 14px 0 ${theme.palette.primary.main}40`,
                                                '&:hover': {
                                                    bgcolor: theme.palette.primary.dark || '#4c2a6b',
                                                    boxShadow: `0 6px 20px 0 ${theme.palette.primary.main}59`,
                                                    transform: 'translateY(-1px)'
                                                },
                                                '&:disabled': {
                                                    bgcolor: '#e5e7eb',
                                                    color: '#9ca3af',
                                                    transform: 'none',
                                                    boxShadow: 'none'
                                                },
                                                transition: 'all 0.2s ease-in-out'
                                            }}>
                                            <span className={getApplicationStatus(mentor.uid) === 'Applied' ? 'applied-text' : ''}>
                                                {getApplicationStatus(mentor.uid)}
                                            </span>
                                        </Button>
                                        <Box sx={{ display: 'flex', gap: 1 }}>
                                            {mentor.linkedIn && (
                                                <IconButton
                                                    href={mentor.linkedIn}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    sx={{ color: 'white' }}
                                                >
                                                    <LinkedInIcon />
                                                </IconButton>
                                            )}
                                            {getPartnerByName(mentor.company) && (
                                                <IconButton
                                                    href={getPartnerByName(mentor.company)?.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    sx={{ color: 'white' }}
                                                    title={`Visit ${getPartnerByName(mentor.company)?.displayName} website`}
                                                >
                                                    <Public />
                                                </IconButton>
                                            )}
                                        </Box>
                                    </CardActions>
                                </Box>
                            </Card>
                        </Grid>
                    )
                })}
            </Grid>
        </Box>
    );
};

export default ListOfMentors;
